import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { ReactNode } from 'react';
import AuthLoadingScreen from './AuthLoadingScreen';

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, isLoading } = useAuth();

  if (isLoading) return <AuthLoadingScreen />;

  if (!isAdmin) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
